import type { TowerValue } from '../types';
import { fromTowerValue } from '../utils/towerValueMapper';
import { EXCESS_TOWER_SCHEMA } from './excessTowerSchema';
import { towerSchemaToYup } from './towerSchemaToYup';

const LAYER_SCHEMAS = towerSchemaToYup(EXCESS_TOWER_SCHEMA);

/**
 * Client-side readiness gate for the excess rater (FPX-5944). A tower is ready
 * to price only when it is well-formed against the excess tower schema: a
 * complete Primary AND Cowbell attachment layer, plus every added underlying
 * layer. This is the schema-strict bar — an incomplete or partial tower never
 * triggers a rater call.
 */
export function isExcessTowerReady(value: TowerValue | null | undefined): boolean {
  if (!value?.props) {
    return false;
  }

  const form = fromTowerValue(value);

  return (
    LAYER_SCHEMAS.primary.isValidSync(form.primary) &&
    LAYER_SCHEMAS.cowbell.isValidSync(form.cowbell) &&
    form.underlying.every((layer) => LAYER_SCHEMAS.underlying.isValidSync(layer))
  );
}
